import {category} from 'store/common';
import {chain, createSelector, groupBy, partition} from 'helpers';
import {RootState} from 'store/root-state.type';

const byType = createSelector(
  (state: RootState) => state.activities.templates,
  (all) => {
    const [templates, examples] = partition(all, template => template.isTemplate);
    return {templates, examples};
  }
);

export const templates = createSelector(
  byType,
  byType => byType.templates,
);

export const examples = createSelector(
  // input
  createSelector(byType, ({examples}) => ({
    all: examples,
    byCategory: groupBy(examples, example => example.habitTypeId)
  })),
  category,
  // result
  ({all, byCategory}, category) => chain(byCategory[category] ?? all).map(example => example.name).uniq().value()
);
